import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full bg-background-50 pt-16" aria-labelledby="hero-heading">
      <div className="w-full px-4 md:px-6 pt-14 pb-8 md:pt-20 md:pb-12">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-12">
          <div className="lg:w-1/2">
            <h1
              id="hero-heading"
              className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.1]"
            >
              全网最火
              <br />
              <span className="text-primary-500">吃瓜视频</span>
              <br />
              每日更新
            </h1>
          </div>

          <div className="lg:w-1/2 lg:pt-3">
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 max-w-md">
              汇聚吃瓜视频在线播放与在线观看吃瓜视频核心入口，整合吃瓜视频在线观看完整版延禧攻略等长尾资源，同步更新国产吃瓜视频及吃瓜视频网站热门爆料。
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <Link
                to="/category/chigua-remen"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-foreground-950 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                立即吃瓜
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 relative overflow-hidden rounded-2xl h-[300px] md:h-[420px]">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20modern%20entertainment%20news%20studio%20background%20with%20abstract%20geometric%20shapes%20in%20deep%20red%20and%20charcoal%20tones%2C%20dramatic%20lighting%20with%20subtle%20lens%20flares%2C%20cinematic%20atmosphere%2C%20minimalist%20composition%2C%20premium%20production%20design%2C%20sleek%20professional%20aesthetic%2C%20dark%20gradient%20with%20red%20accents%2C%20broadcast%20studio%20vibe%2C%208K%20quality%20render&width=1400&height=600&seq=hero-bg-chigua-01&orientation=landscape"
            alt="吃瓜视频网 - 娱乐爆料平台主页横幅"
            className="w-full h-full object-cover object-top"
            title="吃瓜视频网 - 娱乐爆料平台"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-background-50/80"></div>
        </div>
      </div>
    </section>
  );
}